<template>
  <div class="page-container follow-page page-padding-top">
    <top-bar :title="i18n.t('follow.title')"  @back="back"></top-bar>
    <div class="follow-home" v-if="tabIndex == 1">
      <div class="top-info flex-column-start-center ">
        <div class="title">{{$t('follow.desc1')}}</div>
        <div class="btn">
          <Button @click="toPath('tradeApply')">{{$t('follow.btn5')}}</Button>
        </div>
      </div>

      <div class="user-list">
        <List
          v-if="userList.length > 0"
          v-model="loading"
          :finished="finished"
          :finished-text="$t('common.noMore')"
          @load="onLoad">
          <div class="list" v-for="(item, i) in userList" :key="i" @click="toDetail(item)">
            <div class="flex-center info">
              <div class="header">{{item.Name.substring(0,1)}}</div>
              <div class="flex-1">
                <div class="name flex-center-start">
                  <span>{{resetName(item.Name)}}</span>
                  <img :src="levelObj[`url${1}`]" alt="">
                </div>
                <div class="email">
                  {{resetEmail(item.Email)}}
                </div>
              </div>
              <div class="btn" @click.stop="toFollow(item)">
                <Button>{{$t('follow.btn1')}}</Button>
              </div>
            </div>
            <div class="flex-wrap user-statistics">
              <div class="box flex-column-start-center border border-right">
                <div class="label">{{$t('follow.label1')}}(USDT)</div>
                <div class="count green">{{item.TotalProfit.toFixed(2)}}</div>
              </div>
              <div class="box flex-column-end-center border">
                <div class="label">{{$t('follow.label2')}}</div>
                <div class="count ">{{item.TotalTrade}}</div>
              </div>
              <div class="box flex-column-start-center border-right">
                <div class="label">{{$t('follow.label3')}}</div>
                <div class="count ">77/100</div>
              </div>
              <div class="box flex-column-end-center">
                <div class="label">{{$t('follow.label4')}}(USDT)</div>
                <div class="count green">{{item.TotalProfit.toFixed(2)}}</div>
              </div>
            </div>
          </div>
        </List>
      </div>
    </div>
    <div class="follow-user" v-if="tabIndex == 2">
      <div class="user-info flex-center-start">
        <div class="header">P</div>
        <div class="flex-1">
          <div class="name flex-center-start">
            <span>pasike</span>
            <img :src="levelObj['url1']" alt="">
          </div>
          <div class="email">
            p***@gmail.com
          </div>
        </div>
      </div>

      <div class="statistics-box">
        <div class="flex-center-start label">
          <span>{{i18n.t(`follow.label5`)}}(USDT)</span>
          <img :src="showMoney ? eyeUrl2 : eyeUrl" alt="" @click="changeMoneyType">
        </div>

        <div class="flex-center-start money-info" >
          <div class="total flex-end-start">{{moneyStr}}</div>
          <div class="desc flex-end-start">≈ {{showMoney ?  parseFloat(bitMoney).toFixed(4) : '****'}} {{currencyVal}}</div>
        </div>


        <div class="flex today-static">
          <div class="flex-1 flex-column-start-center">
            <div class="name">{{i18n.t(`follow.label6`)}}(USDT)</div>
            <div class="count">1132.39</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="name">{{i18n.t(`follow.label7`)}}(USDT)</div>
            <div class="count" >1132.39</div>
          </div>
        </div>
      </div>

      <div class="menu-box flex">
        <div class="menu flex-1 flex-column-center" @click="toPath('transfer', {type: 6})">
          <img :src="menuUrl1" alt="">
          <span>{{$t('follow.menu1')}}</span>
        </div>
        <div class="menu flex-1 flex-column-center" @click="toPath('assestLog')">
          <img :src="menuUrl2" alt="">
          <span>{{$t('follow.menu2')}}</span>
        </div>
      </div>

      <div class="history-list">
        <div class="top-tab">
          <Tabs
            @change="changeTabs"
            v-model="orderIndex"
            :line-width="0"
            :line-height="0"
            color="#23262F"
            title-inactive-color="#85898F"
            title-active-color="#23262F"
          >
            <Tab v-for="(item, i) in tabList" :key="i" :title="item"></Tab>
          </Tabs>
        </div>
        <div class="list-box" v-if="orderIndex == 1 || orderIndex == 0">
          <List
            v-if="myFollowList.length > 0"
            v-model="loading"
            :finished="orderFinished"
            :finished-text="$t('common.noMore')"
            @load="onLoadOrder">
            <div  class="my-follow-list">
              <div class="list" v-for="(item, i) in myFollowList" :key="i">
                <div class="user flex-center-start">
                  <div class="header flex-center">{{item.User && item.User.Email ? item.User.Email.substring(0, 1) : ''}}</div>
                  <div class="user-name">{{resetEmail(item.User ? item.User.Email : '')}}</div>
                </div>
                <!--期权-->
                <div class="" v-if="item.type == 1">
                  <div  class="label">{{$t('follow.label13')}}</div>
                  <div class="flex-center-start">
                    <div class="name">{{item.Currency.ShortName}}/USDT</div>
                    <div class="time">{{item.CreatedAt}}</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="label">{{$t('follow.label14')}}</div>
                    <div class="label">{{$t('follow.label15')}}</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="tag" :class="item.Direction == 'rose' ? 'green' : 'red'">{{item.Direction == 'rose' ? $t('trade.buy3') : $t('trade.sell3')}}</div>
                    <div class="count">{{item.MarkPrice}}</div>
                  </div>
                  <div class="follow-line flex-center-between  mt-10">
                    <div class="label">{{$t('follow.label16')}}</div>
                    <div class="label">{{$t('follow.label17')}}</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="count">{{item.Settlement}}S</div>
                    <div class="count">{{item.Amount}}</div>
                  </div>
                </div>
                <!--合约-->
                <div class="" v-if="item.type == 2">
                  <div  class="label">{{$t('follow.label18')}}</div>
                  <div class="flex-center-start">
                    <div class="name">BTC/USDT</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="flex-center">
                      <div class="tag red">{{$t('follow.label19')}}</div>
                      <div class="ml-5"> {{$t('follow.label20')}} 10X</div>
                    </div>
                    <div class="time">2024-01-22 12:33:44</div>
                  </div>

                  <div class="follow-line flex-center-between mt-10">
                    <div class="label">{{$t('follow.label21')}}</div>
                    <div class="label">{{$t('follow.label22')}}</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="count">12903.22</div>
                    <div class="count">2200.22</div>
                  </div>

                  <div class="follow-line flex-center-between  mt-10">
                    <div class="label">{{$t('follow.label23')}}</div>
                    <div class="label">{{$t('follow.label24')}}</div>
                  </div>
                  <div class="follow-line flex-center-between">
                    <div class="count">900</div>
                    <div class="count">11200.22</div>
                  </div>

                  <div class="follow-btn-line  flex-center-between">
                    <Button>{{$t('follow.label25')}}</Button>
                    <Button>{{$t('follow.label26')}}</Button>
                  </div>
                </div>
              </div>
            </div>
          </List>
          <div class="empty flex-column-center" v-if="myFollowList.length == 0">
            <img :src="emptyUrl" alt="">
            <div class="desc">{{$t('common.empty')}}</div>
          </div>
        </div>

        <div class="list-box" v-if="orderIndex == 2">
          <div class="profit-box">
            <div class="box-title">{{$t('follow.label27')}}</div>
            <div class="flex-center box">
              <div class="flex-1 flex-column-start-center">
                <div class="label">{{$t('follow.label28')}}(USDT)</div>
                <div class="count" :class="statisticsData.OptionTodayProfit > 0 ? 'green' : (statisticsData.OptionTodayProfit < 0 ? 'red' : '')">{{statisticsData.OptionTodayProfit > 0 ? '+' : ''}}{{statisticsData.OptionTodayProfit}}</div>
              </div>
              <div class="flex-1 flex-column-end-center">
                <div class="label">{{$t('follow.label29')}}(USDT)</div>
                <div class="count ">{{statisticsData.OptionTotalAmount}}</div>
              </div>
            </div>
          </div>

           <div class="profit-box">
            <div class="box-title">{{$t('follow.label30')}}</div>
            <div class="flex-center box">
              <div class="flex-1 flex-column-start-center">
                <div class="label">{{$t('follow.label28')}}(USDT)</div>
                <div class="count"  :class="statisticsData.ContractTodayProfit > 0 ? 'green' : (statisticsData.ContractTodayProfit < 0 ? 'red' : '')">{{statisticsData.ContractTodayProfit > 0 ? '+' : ''}}{{statisticsData.ContractTodayProfit}}</div>
              </div>
              <div class="flex-1 flex-column-end-center">
                <div class="label">{{$t('follow.label29')}}(USDT)</div>
                <div class="count ">{{statisticsData.ContractTotalAmount}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-box" v-if="orderIndex == 3">
          <div class="query-btn flex-center-start">
            <Button class="btn" :class="userType == 1 ? 'active' : ''" @click="changeType(1)">{{$t('follow.btn2')}}</Button>
            <Button class="btn" :class="userType == 2 ? 'active' : ''" @click="changeType(2)">{{$t('follow.btn3')}}</Button>
          </div>

          <div class="user-list">
            <List
              v-if="followUserList.length > 0"
              v-model="loading"
              :finished="userFinished"
              :finished-text="$t('common.noMore')"
              @load="onLoadUser">
              <div class="list" v-for="(item, i) in followUserList" :key="i">
                <div class="user-info small flex-center-between">
                  <div class="flex-center">
                    <div class="header">{{item.CopyTradingSettings ? item.CopyTradingSettings.Name.substring(0,1) : 'T'}}</div>
                    <div class="name flex-center-start">
                      {{item.CopyTradingSettings ? item.CopyTradingSettings.Name : ''}}
                    </div>
                  </div>
                  <div>
                    <Button class="cancel-btn">{{$t('follow.btn4')}}</Button>
                  </div>
                </div>
                <div class="mt-20 flex-center-between">
                  <div class="label">{{$t('follow.label11')}}</div>
                  <div class="count" :class="item.TotalProfitAmount < 0 ? 'red' : 'green'">{{item.TotalProfitAmount}}</div>
                </div>
              </div>
            </List>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-bar-outer">
      <div class="tab-bar">
        <div class="tab" @click="changeTab(1)" :class="{active: tabIndex == 1}">
          <div class="icon">
            <img :src="homeUrl2" alt="" v-if="tabIndex == 1">
            <img :src="homeUrl" alt="" v-else>
          </div>
          <div class="title">{{i18n.t(`follow.tab1`)}}</div>
        </div>
        <div class="tab" @click="changeTab(2)" :class="{active: tabIndex == 2}">
          <div class="icon">
            <img :src="userUrl2" alt="" v-if="tabIndex == 2">
            <img :src="userUrl" alt="" v-else>
          </div>
          <div class="title">{{i18n.t(`follow.tab2`)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Tabs, Tab, List } from 'vant'
import { copyTradeList, copyTradeLog, copyTradeStatistics, copyTradeOrderList } from '@/api/trade'
import topBar from '@/components/topBar'
import { resetName, resetEmail } from '@/utils/common'
export default {
  name: 'home',
  components: {
    topBar,
    Button,
    Tabs,
    Tab,
    List
  },
  data() {
    return {
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      page: {
        page: 1,
        limit: 10
      },
      userPage: {
        page: 1,
        limit: 10
      },
      orderPage: {
        page: 1,
        limit: 10
      },
      isInit: false,
      loading: false,
      finished: false,
      userFinished: false,
      orderFinished: false,
      totalPage: 1,
      userTotalPage: 1,
      orderTotalPage: 1,
      homeUrl: require('../../assets/imgs/follow-home.png'),
      homeUrl2: require('../../assets/imgs/follow-home2.png'),
      userUrl: require('../../assets/imgs/follow-user.png'),
      userUrl2: require('../../assets/imgs/follow-user2.png'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      menuUrl1: require('../../assets/imgs/icon-transfer3.png'),
      menuUrl2: require('../../assets/imgs/icon-debt.png'),
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      levelObj: {
        url1: require('../../assets/imgs/level1.png'),
        url2: require('../../assets/imgs/level2.png'),
      },
      userList: [],
      followUserList: [],
      allFollowUserList: [],
      showMoney: true,
      userMoney: 12312.31,
      bitMoney: '0.00',
      myFollowList: [],
      statisticsData: {
        OptionTodayProfit: '0.00',
        OptionTotalAmount: '0.00',
        ContractTodayProfit: '0.00',
        ContractTotalAmount: '0.00',
      },
      orderStatus: 0,
      orderCount: 0
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
     moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    tabList() {
      return [`${this.$t('follow.order1')}(${this.orderCount})`, this.$t('follow.order2'), this.$t('follow.order3'), this.$t('follow.order4')]
    },
    currencyVal() {
      return this.$store.state.currencyVal
    },
    currencyRate() {
      return this.$store.state.currencyRate
    },
  },
  mounted() {
    let index =  sessionStorage.getItem('followIndex')
    this.tabIndex = index || 1
    this.init()
    this.onLoadOrder()
    this.initFollowUserList()
    this.initStatistics()
    this.bitMoney = this.userMoney * this.currencyRate
  },
  methods: {
    resetEmail,
    resetName,
    changeTab(i) {
      this.tabIndex = i
      sessionStorage.setItem('followIndex', i)
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    initStatistics() {
      copyTradeStatistics().then(res => {
        this.statisticsData = res.data
      })
    },
    toPath(path, query) {
      if (path) {
        this.$router.push({
          name: path,
          query: query || {}
        })
      }
    },
    changeType(type) {
      this.userType = type
      this.followUserList = this.allFollowUserList.filter(v => {
        return v.Status == this.userType
      })
    },
    toDetail(data) {
      sessionStorage.setItem('copyTradeData', JSON.stringify(data))
      this.$router.push({
        name: 'followDetail',
        query: {
          id: data.ID
        }
      })
    },
    toFollow(data) {
      sessionStorage.setItem('copyTradeData', JSON.stringify(data))
      this.$router.push({
        name: 'tradeFollow'
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    init(isAdd) {
      this.loading = true
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      copyTradeList(form).then(res => {
        if (isAdd) {
          this.userList = this.userList.concat(res.data.Items)
        } else {
          this.userList = res.data.Items
        }
        this.totalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.totalPage <= this.page.page) {
          this.finished = true
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        this.isInit = true
        this.loading = false
      })
    },
    onLoadUser() {
      this.userPage.page += 1
      this.initFollowUserList(true)
    },
    initFollowUserList(isAdd) {
      this.loading = true
      let form = new FormData()
      form.append('current', this.userPage.page)
      form.append('pageSize', this.userPage.limit)
      copyTradeLog(form).then(res => {
        if (isAdd) {
          this.allFollowUserList = this.allFollowUserList.concat(res.data.Items)
        } else {
          this.allFollowUserList = res.data.Items
        }
        this.followUserList = this.allFollowUserList.filter(v => {
          return v.Status == this.userType
        })
        this.userTotalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.userTotalPage <= this.userPage.page) {
          this.userFinished = true
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        this.isInit = true
        this.loading = false
      })
    },
    onLoadOrder() {
      this.orderPage.page += 1
      this.initFollowOrder(true)
    },
    initFollowOrder(isAdd) {
      this.loading = true
      let form = new FormData()
      form.append('current', this.orderPage.page)
      form.append('pageSize', this.orderPage.limit)
      form.append('Status', this.orderStatus)
      copyTradeOrderList(form).then(res => {
        if (isAdd) {
          this.myFollowList = this.myFollowList.concat(res.data.Items)
        } else {
          this.myFollowList = res.data.Items
        }
        this.orderTotalPage = res.data.Pagination ? res.data.Pagination.totalPage : 1
        if (this.orderTotalPage <= this.orderPage.page) {
          this.orderFinished = true
        }
        this.isInit = true
        this.loading = false
      }).catch(err => {
        this.isInit = true
        this.loading = false
      })
    },
    changeTabs() {
      if (this.orderIndex == 3) {
         this.userPage.page = 1
        this.initFollowUserList()
      } else if (this.orderIndex == 0) {
        this.orderPage.page = 1
        this.orderStatus = 0
        this.initFollowOrder()
      } else if (this.orderIndex == 1) {
        this.orderPage.page = 1
        this.orderStatus = 1
        this.initFollowOrder()
      }
    }
  }
}
</script>